import { apiEndPoints, apiMethods } from '../../../../../utils/apiConstants'
import customAxios from '../../../../../utils/customAxios'

export const fetchLandingPageCategoriesThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.getCategories, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const fetchLandingPageNonDigitalCategoriesThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.getNonDigitalCategories, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const fetchDigitalProductsThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.gameProductsListing, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
export const getAllCategoriesThunk = async () => {
	try {
		const responseJson = await customAxios[apiMethods.get](apiEndPoints?.getAllCategories)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

// landingPageApis.js

export const fetchProductsByCategoryThunk = async (id) => {
	let endpoint = ''

	// Use a switch or if-else to determine the endpoint based on category
	// switch (category) {
	// case 'grocery':
	// 	endpoint = '/api/products/grocery' // Adjust this if needed
	// 	break
	// case 'fashion':
	// 	endpoint = '/api/products/fashion' // Adjust this if needed
	// 	break
	// case 'digital-products':
	// 	break
	// 	default:
	// 		throw new Error('Unknown category') // Handle error for unknown category
	// }
	const body = {
		categoryId: id,
	}
	endpoint = apiEndPoints.gameProductsListing // Using your existing endpoint
	try {
		// Make API call to the correct endpoint based on category
		const responseJson = await customAxios[apiMethods.post](endpoint, body)
		return responseJson.data // Assuming the data is within responseJson.data
	} catch (error) {
		throw error
	}
}

export const fetchProductDetailsThunk = async (teamId) => {
	try {
		// Make API call to the correct endpoint based on category
		const responseJson = await customAxios[apiMethods.get](apiEndPoints.gameProductDetails(teamId))
		return responseJson.data // Assuming the data is within responseJson.data
	} catch (error) {
		throw error
	}
}

export const fetchNonDigitalProductDetailsThunk = async (productId) => {
	try {
		// Make API call to the correct endpoint based on category
		const responseJson = await customAxios[apiMethods.get](apiEndPoints.nonDigitalProductDetails(productId))
		return responseJson.data // Assuming the data is within responseJson.data
	} catch (error) {
		throw error
	}
}

export const fetchDigitalProductDetailsThunk = async (productId) => {
	try {
		// Make API call to the correct endpoint based on category
		const responseJson = await customAxios[apiMethods.get](apiEndPoints.digitalProductDetails(productId))
		return responseJson.data // Assuming the data is within responseJson.data
	} catch (error) {
		throw error
	}
}

export const frequestlyBroughtTogetherProductThunk = async (body) => {
	try {
		// Make API call to the correct endpoint based on category
		const responseJson = await customAxios[apiMethods.post](apiEndPoints.frequentlyBroughtTogetherProducts, body)
		return responseJson.data // Assuming the data is within responseJson.data
	} catch (error) {
		throw error
	}
}

export const createProductReviewThunk = async (body) => {
	try {
		// Make API call to the correct endpoint based on category
		const responseJson = await customAxios[apiMethods.post](apiEndPoints.createProductReview, body)
		return responseJson.data // Assuming the data is within responseJson.data
	} catch (error) {
		throw error
	}
}

export const getUserProductReviewThunk = async (body) => {
	try {
		// Make API call to the correct endpoint based on category
		const responseJson = await customAxios[apiMethods.post](apiEndPoints.getUserProductReview, body)
		return responseJson.data // Assuming the data is within responseJson.data
	} catch (error) {
		throw error
	}
}

export const updateProductReviewThunk = async (body) => {
	try {
		// Make API call to the correct endpoint based on category
		const responseJson = await customAxios[apiMethods.post](apiEndPoints.updateProductReview, body)
		return responseJson.data // Assuming the data is within responseJson.data
	} catch (error) {
		throw error
	}
}

export const getPerticularProductAllReviewsThunk = async (body) => {
	try {
		// Make API call to the correct endpoint based on category
		const responseJson = await customAxios[apiMethods.post](apiEndPoints.getPerticularProductAllReviews, body)
		return responseJson.data // Assuming the data is within responseJson.data
	} catch (error) {
		throw error
	}
}

export const updateProductLikeAndDislikeCountThunk = async (body) => {
	try {
		// Make API call to the correct endpoint based on category
		const responseJson = await customAxios[apiMethods.post](apiEndPoints.updateProductLikeAndDislikeCount, body)
		return responseJson.data // Assuming the data is within responseJson.data
	} catch (error) {
		throw error
	}
}
